export const GET_USER_NOTIFICATION_SETTINGS_QUERY = 'GET_USER_NOTIFICATION_SETTINGS_QUERY';
